<template>
  <div class="chat-container">
    <!-- <div class="chat-header">
      <h2>Chat Interface</h2>
    </div> -->
    <div class="chat-body">
      <div class="chat-history" ref="chatContainer">
        <div v-for="(message, index) in messages" :key="index" :class="['message', message.type]">
          <!-- {{ message.text }} -->    
            <div v-html="message.text"></div>
        </div>
        <!-- 计时器显示 -->
        <div v-if="showTimer" class="timer">
          {{ timerValue.toFixed(1) }}s
        </div>
      </div>
    </div>
    <div class="chat-footer">
      <form @submit.prevent="submitQuestion">
        <input v-model="question" type="text" placeholder="请输入您想问的问题" />
        <button type="submit">发送</button>
      </form>
    </div>
  </div>
</template>

<script>
import io from 'socket.io-client';
import axios from 'axios';
import marked from 'marked';
import DOMPurify from 'dompurify';

export default {
  data() {
    return {
      question: '',
      messages: [],
      currentAnswer: '',
      user_id: null,
      // 计时器相关数据
      showTimer: false,
      timerValue: 0,
      timerInterval: null
    };
  },
  created() {
    this.user_id = uuidv4();  // 生成一个唯一的用户ID
    this.socket = io('https://question.socket.51ydb.cn', { query: { user_id: this.user_id } });
    this.socket.on('connect', () => {
      console.log(`User ${this.user_id} connected`);
    });
    this.socket.on('answer', (data) => {  
      if (this.showTimer) {
        this.stopTimer();
      }
      this.currentAnswer += data.answer;
    });
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer;
        container.scrollTop = container.scrollHeight;
      });
    },
    startTimer() {
      this.showTimer = true;
      this.timerValue = 0;
      const startTime = Date.now();
      
      this.timerInterval = setInterval(() => {
        this.timerValue = (Date.now() - startTime) / 1000;
      }, 100);
    },
    // 停止计时器
    stopTimer() {
      this.showTimer = false;
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    submitQuestion() {
      if (this.timerInterval) {
        this.stopTimer();
      }
      const newQuestion = this.question;
      this.messages.push({ type: 'question', text: newQuestion });

      this.currentAnswer = ''; // 重置当前答案
      this.messages.push({ type: 'answer', text: '' }); // 添加一个空的答案条目

      this.startTimer();

      axios.post('https://question.socket.51ydb.cn/api/question', { question: newQuestion, user_id: this.user_id })
        .then(() => {
          const html = marked(this.currentAnswer);
          DOMPurify.sanitize(html)
          const sanitizedHtml = DOMPurify.sanitize(html);
          this.messages[this.messages.length - 1].text = sanitizedHtml; // 更新最后一个答案条目的内容
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      this.question = ''; // 清空输入框
    }
  },
  watch: {
    currentAnswer(newVal) {
      if (newVal) {
        const html = marked(newVal);
        const sanitizedHtml = DOMPurify.sanitize(html);
        this.messages[this.messages.length - 1].text = sanitizedHtml; // 更新最后一个答案条目的内容
        this.scrollToBottom()
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前清理计时器
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
};

// 生成UUID的函数
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 85vh;
}

.chat-header {
  background-color: #f1f1f1;
  padding: 10px;
  text-align: center;
}

.chat-body {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  box-sizing: border-box;
  padding-bottom: 10vh;
}

.chat-history {
  flex-grow: 1;
  padding: 10px;
  overflow-y: auto;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}

.message {
  margin: 5px 0;
  padding: 8px;
  border-radius: 5px;
  max-width: 70%;
  text-align: left; /* 左对齐 */
}

.question {
  background-color: #FF6900;
  align-self: flex-end;
  color: #ffffff;
  margin-right: 46px;
  position: relative;
}
.question::after{
  position: absolute;
  right: -46px;
  top: 0;
  content: ' ';
  background: url(https://oss.mcloud.moveclub.cn/2024/movewell/avatar.png) no-repeat;
  width: 35px;
  height: 35px;
  background-size: 100%;
}

.answer {
  background-color: #ffffff;
  border: 2px solid rgba(228,223,234,1);
  align-self: flex-start;
  color: #505862;
  margin-left: 46px;
  position: relative;
}
.answer::before{
  position: absolute;
  left: -46px;
  top: 0;
  content: ' ';
  background: url(https://oss.mcloud.moveclub.cn/2024/movewell/%E6%AF%8F%E5%B0%8F%E6%AD%A5%402x.png) no-repeat;
  width: 35px;
  height: 35px;
  background-size: 100%;
}

.chat-footer {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  background-color: #f1f1f1;
  border-top: 1px solid #ddd;
  position: fixed;
  bottom:0;
  left: 0;
  width: 100%;
}

.chat-footer form {
  display: flex;
  flex-grow: 1;
}

.chat-footer input {
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #FF6900;
  border-radius: 5px 0 0 5px;
}

.chat-footer button {
  padding: 10px 20px;
  background-color: #FF6900;
  color: white;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
}

.chat-footer button:hover {
  background-color: #FF6900;
}

.timer {
  align-self: baseline;
  margin-left: 40px;
  padding: 4px 8px;
  background-color: #f0f0f0;
  border-radius: 15px;
  font-size: 12px;
  color: #666;
}
</style>